import { useState, useRef } from "react";

import { Button, ButtonGroup, IconButton, Grow, Paper, Popper, MenuItem, MenuList, Grid } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

export const ButtonGeneric = ({ onClick, text, type = "button", fullWidth = false, color = "primary", ...props }) => {
  return (
    <Button
      type={type}
      variant="contained"
      fullWidth={fullWidth}
      color={color}
      onClick={onClick}
      {...props}
    >
      {text}
    </Button>
  );
};

export const ButtonGroupGeneric = ({ variant = "contained", color="primary",  fullWidth = true , buttonList, ...props }) => {
  return (
    <ButtonGroup variant={variant} color={color} fullWidth={fullWidth} {...props}>
      {buttonList.map((buttonProps, index)=> (
        <ButtonGeneric 
          key={index}
          {...buttonProps}
        />
      ))}
    </ButtonGroup>
  );
}

export const IconButtonGeneric = ({onClick = () => {}, Icon = Delete, ariaLabel = "delete",...props}) => {
  return (
    <div {...props.divProps}>
      <IconButton aria-label={ariaLabel} onClick={onClick} {...props}>
        <Icon />
      </IconButton>
    </div>
  );
}

export const ButtonSplitGeneric = ({ buttons = [], fileType }) => {
  const fileInputRef = useRef(); 
  const anchorRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <Grid container>
      <Grid item xs={12}>
        <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
          {fileType && (
            <input 
                type='file'
                name='archivos'
                ref={fileInputRef}
                style={{display:'none'}}
                onChange={(e)=> buttons[selectedIndex]?.onClick((e.target.files[0]))}
            />
          )}
          <Button 
            style={{backgroundColor: "#ddd"}} 
            onClick={() => { 
              if(!fileType){
                const buttonClick = buttons[selectedIndex]?.onClick;
                if(buttonClick) buttonClick(); 
              }else fileInputRef.current.click();
            }}
          >
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: "0.75em"}}>
              {buttons[selectedIndex]?.icon}
              {buttons[selectedIndex]?.label}
            </div>
          </Button>
          <Button
            style={{backgroundColor: "#ddd"}}
            size="small"
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label="select merge strategy"
            aria-haspopup="menu"
            disabled={buttons.length <= 1}
            onClick={() => {
              setOpen((prevOpen) => !prevOpen);
            }}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{zIndex:99, marginTop: "0.2em"}}>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener 
                  onClickAway={({ target }) => {
                    if (anchorRef.current && anchorRef.current.contains(target)) return;
                    setOpen(false);
                  }}
                >
                  <MenuList id="split-button-menu">
                    {buttons.map(({label, disabled}, index) => (
                      <MenuItem
                        key={index}
                        disabled={disabled}
                        selected={index === selectedIndex}
                        onClick={() => {
                          setSelectedIndex(index);
                          setOpen(false);
                        }}
                      >
                        {label}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Grid>
    </Grid>
  );
}
